/*****************************************************
Naam: index.js
Datum: 2024-01-18 18:00
Versie: 1.0.0
Auteur: Ragnar Standhardt
******************************************************
Beschrijving:
Entry point voor de React applicatie.
******************************************************/

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Suppress React warnings in development
if (process.env.NODE_ENV === 'development') {
  const originalWarn = console.warn;
  console.warn = (...args) => {
    if (typeof args[0] === 'string' && 
        (args[0].includes('findDOMNode') || 
         args[0].includes('StrictMode'))) {
      return;
    }
    originalWarn.apply(console, args);
  };
  
  const originalError = console.error;
  console.error = (...args) => {
    if (typeof args[0] === 'string' && 
        (args[0].includes('findDOMNode') || 
         args[0].includes('StrictMode'))) {
      return;
    }
    originalError.apply(console, args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);